import useReveal from "../hooks/useReveal";
import { Sparkles, Gem, Ruler, HeartHandshake } from "lucide-react";
import { features } from "../mock/mock";

const iconMap = { Sparkles, Gem, Ruler, HeartHandshake };

export default function Features() {
  const [ref, inView] = useReveal();

  return (
    <section className="py-24 md:py-32 bg-[#2A2521] relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-[#A17E4A]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div ref={ref} className={`max-w-2xl mb-16 reveal ${inView ? "in-view" : ""}`}>
          <p className="text-[#E7CFA6] tracking-[0.25em] uppercase text-xs mb-4">Where Quality Meets Style</p>
          <h2 className="font-serif text-3xl md:text-5xl text-white mb-5">
            Why Homeowners Choose GoDrapery
          </h2>
          <p className="text-white/70 text-lg">
            We believe your windows deserve the same care and attention as the rest of your home.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <div
                key={f.title}
                className={`reveal ${inView ? "in-view" : ""}`}
                style={{ animationDelay: `${i * 110}ms` }}
              >
                <div className="w-14 h-14 rounded-xl bg-[#A17E4A]/15 border border-[#A17E4A]/30 flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6 text-[#E7CFA6]" />
                </div>
                <h3 className="font-serif text-xl text-white mb-3">{f.title}</h3>
                <p className="text-white/60 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
